module.exports = "<div class=\"icon flag flag-{{country}}\"></div>";